import api from "./api"
import { RegistrarLogErro } from "./clientefiel"

function tratamentoResponse(response, chamada) {
    if (response.data.codErro > 0)
        return { retornoErro: response.data.codErro, mensagem: response.data.mensagem }
    else if (typeof response.data == "string" && response.data != "")
        return {
            retornoErro: 1,
            mensagem: chamada + " - Erro inesperado, entre em contato com os reponsáveis.",
        }
    else return response.data
}

export const salvarParametro = async (idEstabelecimento, dados, autorizacao) => {
    const url = `parametro/salvar/${idEstabelecimento}`
    const headers = {
        "Content-Type": "application/json",
        Authorization: autorizacao,
    }

    try {
        const response = await api.post(url, dados, { headers })
        return tratamentoResponse(response, "salvarParametro")
    } catch (error) {
        RegistrarLogErro(error, "salvarParametro")
        return { retornoErro: 1, mensagem: error.message }
    }
}

export const deletarParametro = async (idEstabelecimento, id, autorizacao) => {
    const url = `/parametro/excluir/${idEstabelecimento}/${id}`
    const headers = {
        "Content-Type": "application/json",
        Authorization: autorizacao,
    }

    try {
        const response = await api.delete(url, { headers })
        return tratamentoResponse(response, "deletarParametro")
    } catch (error) {
        RegistrarLogErro(error, "deletarParametro")
        return { retornoErro: 1, mensagem: error.message }
    }
}

export const obterParametrosGerais = async (idEstabelecimento, autorizacao) => {
    const url = `parametro/listar/${idEstabelecimento}`
    const headers = {
        "Content-Type": "application/json",
        Authorization: autorizacao,
    }

    try {
        const response = await api.get(url, { headers: headers })

        return tratamentoResponse(response, "obterParametrosGerais")
    } catch (error) {
        RegistrarLogErro(error, "obterParametrosGerais")
        return { retornoErro: 1, mensagem: error.message }
    }
}
